export default {
      id: "icon--email-signup-usage",
      viewBox: "0 0 32 24",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--email-signup-usage",
      toString: function () {
        return this.url;
      }
    }